import { request } from 'graphql-request';

export default request.bind(null, 'https://api.fashionunited.com/graphql/');
